module.exports = __webpack_public_path__ + "static/media/logoPoliciaZaragoza.a3744a6b.webp";